export const TextArea = ({ id, text, onChange, disabled, className }) => {

    function handleChange(e) {
        e.target.classList.remove("border-danger");
        /*if (setText !== undefined)
            setText(elem.options[elem.value].text)
        if (setValue !== undefined)
            setValue(elem.value)*/
    }

    return (
        <div className={className}>
            <div class="mb-3">
                <label for={id} class="form-label fw-bold">{text}</label>
                {/*<div id={props.idSeccion + "Helper"} class={"form-text textoErrores ms-1 " + (props.helper ? 'd-inline' : '')}>{props.helper}</div>*/}
                <textarea class={"form-control d-block"} disabled={disabled} id={id} rows="3"
                    onChange={handleChange} />{/*aria-describedby={props.idSeccion + "Helper"}*/}

            </div>
        </div>
    )
}